module.exports = __webpack_public_path__ + "media/images/communities/logos/ao4-d935f73d840b653ba65e41c2aad9237f.png";